import React, {useState} from 'react'
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import useForm from '../../Common/Forms/useForm';
import validaEmail from '../../Common/Forms/Validations/validaEmail';
import validaTel from '../../Common/Forms/Validations/validaTel';
import {validaDataNascimento} from '../../Common/Forms/Validations/validaData';
import Field from '../../Common/Forms/Field';
import FieldSwitch from '../../Common/Forms/FieldSwitch';
import FieldSenha from '../../Common/Forms/FieldSenha';
import FieldMasked from '../../Common/Forms/FieldMasked';
import EditUserPermissionsUI from './EditUserPermissionsUI';

const Grid = styled.div`
  display: grid;
  justify-content: center;	
  /* padding: 10px 30px; */
  grid-gap: 10px;
  grid-template-columns: 250px 250px 250px;
  grid-template-rows: auto;
  grid-template-areas:
    "nome   usuario   email"
    "telCelular telFixo ativo"
    "senha confirmaSenha dataNascimento";
`

function maskTest (raw) {
  if (!raw) return []
  if (raw.length < 4) return ['(', /\d/,/\d/,')', /\d/]
  let primeiroNum = parseInt(raw.charAt(5))
  if (primeiroNum > 5) return ['(', /\d/,/\d/,')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  return ['(', /\d/,/\d/,')', ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
}

function TextMaskDate(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref => {inputRef(ref ? ref.inputElement : null)}}
      mask={[/\d/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /[9|0]/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

function TextMaskTelefone(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref => {inputRef(ref ? ref.inputElement : null)}}
      mask={maskTest}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

const FieldDate = props => <FieldMasked MaskCmp={TextMaskDate} {...props} />
const FieldTelefone = props => <FieldMasked MaskCmp={TextMaskTelefone} {...props} />

const Bottom = styled.div`
  background: linear-gradient(#FFF, #EEE);
  padding: 10px;
  display: flex;
  justify-content: center;
  & > button {
    margin: 0px 3px;
  }
`

export default function EditUser(props) {
  // data...
  let DEFAULT_VALUES = {
    nome: "",
    dataNascimento: null,
    email: "",
    telCelular: "",
    telFixo: "",
    permissoes: null,
    usuario: "",
    senha: "",
    confirmaSenha: "",
    ativo: true
  }
  const f = useForm(props.values, DEFAULT_VALUES)
  return (
    <Paper style={{ marginTop: "25px" }}>
      <SimpleTabs f={f} />
      <Bottom>
        <Button variant="contained" color="primary">Salvar</Button>
        {" "}
        <Button variant="contained">Cancelar</Button>
      </Bottom>
    </Paper>
  )
}

function EditUserUI(props) {
  const { f } = props;
  const [ showSenha, setShowSenha ] = useState(false);
  // VALIDAÇÂO SENHA
  const toggleShowSenha = () => setShowSenha(v => !v)
  const { senha, confirmaSenha } = f.values;
  if (f.wasTouched("senha") && f.wasTouched("confirmaSenha") && senha !== confirmaSenha) {
    if (!f.hasError("senha")) {
      let m = "Senhas não conferem"
      f.setErrors({ ...f.errors, senha: m, confirmaSenha: m })
    }
  }
  if (f.hasError("senha") && senha === confirmaSenha) {
    f.setErrors({ ...f.errors, senha: null, confirmaSenha: null })
  }
  return (
    <Grid>
      <Field name="nome" label="Nome" {...f} />
      <Field name="usuario" label="Usuário" {...f} />
      <Field name="email" label="E-mail" {...f} valida={validaEmail} />
      <FieldTelefone name="telCelular" label="Telefone Celular" valida={validaTel} {...f} />
      <FieldTelefone name="telFixo" label="Telefone Fixo" valida={validaTel} {...f} />
      <FieldSwitch name="ativo" label="Ativo" {...f} />
      <FieldSenha name="senha" label="Senha"
        show={showSenha} toggle={toggleShowSenha}
        {...f}
      />
      <FieldSenha name="confirmaSenha" label="Confirmar Senha"
        show={showSenha} toggle={toggleShowSenha}
        {...f}
      />
      <FieldDate name="dataNascimento" label="Data de Nascimento" {...f} valida={validaDataNascimento} />
    </Grid>
  )
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}


function SimpleTabs (props) {
  const { f } = props;
  const [tab, setTab] = React.useState(0);

  function tabChange(event, newTab) {
    setTab(newTab);
  }

  return (
    <div>
    <AppBar position="static">
      <Tabs value={tab} onChange={tabChange}>
        <Tab label="Dados Pessoais" />
        <Tab label="Permissões" />
      </Tabs>
    </AppBar>

      {tab === 0 && <TabContainer><EditUserUI f={f} /></TabContainer>}
      {tab === 1 && <TabContainer><EditUserPermissionsUI f={f} /></TabContainer>}
    </div>
  );
}
